import { RegistreVciComponent } from './registre-vci.component';

export const REGISTRE_VCI_ROUTES = [{ path: '', component: RegistreVciComponent, data: { menu: { libelle: 'Registre VCI' } } }];
